import { useSelector } from 'react-redux'
import {Route, Redirect} from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import { FixedLoading } from '../newsForm/newsFormElements'

const ProtectedRoute = ({component: Component, ...rest}) => {
    const {user, isLoading} = useSelector(state => state.user)

    if(isLoading) return (
        <FixedLoading><CircularProgress color="secondary" /></FixedLoading>

    )

    return (
        <Route {...rest} render={props => user?.isAdmin? (<>
            <Component {...rest} {...props} />
        </>):(<Redirect to='/' />)}>
            
        </Route>
    )
}

export default ProtectedRoute
